import { useContext } from "react";
import urlTransformerContext from "./urlTransformerContext.mjs";
function useUrlTransformer() {
  return useContext(urlTransformerContext);
}
export { useUrlTransformer as default };